var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablet = function SvgTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "tablet_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tablet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09 18.75q-.63 0-1.069-.437a1.45 1.45 0 0 1-.437-1.07V2.757q0-.63.437-1.068a1.45 1.45 0 0 1 1.07-.438h7.82q.63 0 1.069.438.437.437.437 1.068v14.488q0 .63-.437 1.069a1.45 1.45 0 0 1-1.07.437zm-.256-2.292v.786q0 .096.08.176t.176.08h7.82a.24.24 0 0 0 .177-.08.24.24 0 0 0 .08-.177v-.785zm0-1.25h8.333V4.792H5.834zm0-11.666h8.333v-.786a.24.24 0 0 0-.08-.176.25.25 0 0 0-.176-.08H6.09a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.176z"
  }))));
};
export default SvgTablet;